import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

// Styles
import './assignitem.scss'

// import components
import DateChangePopup from '../../../shared/components/DateChangePopup'
import DateActions from '../../../shared/components/DateChangePopup/DateActions'

// Actions
import { assignUsers } from '../../../actions/assign'

// import utils
import { renderTime, renderFullDate } from '../../../utils/time'
import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'
import IconAccordion from '../../../shared/elements/iconAccordion'
import { AssignmentIcons, AssignmentStepStatus } from '../../../shared/elements/icons'
import { OrderSteps } from '../../../constants'
import Avatar from '../../../shared/elements/avatar'
import Icon from '../../../shared/elements/icon'

class AssignItem extends Component {
  constructor (props) {
    super(props)
    this.state = {
      item: {}
    }
    this.renderStep = this.renderStep.bind(this)
    this.onStepClick = this.onStepClick.bind(this)
    this.navigateToOrder = this.navigateToOrder.bind(this)
  }

  componentDidMount () {
    this.setState({
      item: this.props.item
    })
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(this.props.item, nextProps.item)) {
      this.setState({
        item: nextProps.item
      })
    }
  }

  /*
  shouldComponentUpdate (nextProps) {
    return true
    /*
    console.log(!isEqual(this.state.item, nextProps.item), nextProps.item)
    if (!isEqual(this.state.item, nextProps.item) || Object.keys(this.state.item).length === 0) {
      return true
    }
    return false
    /
  }
  */

  renderTime (time) {
    if (this.props.auth.user.CustomerId === '-1') {
      return renderTime(time)
    } else {
      return renderFullDate(time)
    }
  }

  getStepIcon (id, color) {
    // the second img red is used on mousse over
    switch (id) {
      case OrderSteps.NEW_ORDER: // 1
        return (
          <div className='icon-box'>
            {color === 'black' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_New_Black} size='t' />}
            {color === 'white' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_New_White} size='t' />}
            {color === 'red' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_New_Red} size='t' />}
            <Icon imgClassName={'hover-icon'} icon={AssignmentStepStatus.Step_New_Red} size='t' />
          </div>
        )
      case OrderSteps.PREPARING: // 2
        return (
          <div className='icon-box'>
            {color === 'black' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Preparing_Black} size='t' />}
            {color === 'white' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Preparing_White} size='t' />}
            {color === 'red' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Preparing_Red} size='t' />}
            <Icon imgClassName={'hover-icon'} icon={AssignmentStepStatus.Step_Preparing_Red} size='t' />
          </div>
        )
      case OrderSteps.FILLING: // 3
        return (
          <div className='icon-box'>
            {color === 'black' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Filling_Black} size='t' />}
            {color === 'white' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Filling_White} size='t' />}
            {color === 'red' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Filling_Red} size='t' />}
            <Icon imgClassName={'hover-icon'} icon={AssignmentStepStatus.Step_Filling_Red} size='t' />
          </div>
        )
      case OrderSteps.SANDING: // 4
        return (
          <div className='icon-box'>
            {color === 'black' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Sanding_Black} size='t' />}
            {color === 'white' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Sanding_White} size='t' />}
            {color === 'red' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Sanding_Red} size='t' />}
            <Icon imgClassName={'hover-icon'} icon={AssignmentStepStatus.Step_Sanding_Red} size='t' />
          </div>
        )
      case OrderSteps.PAINTING: // 5
        return (
          <div className='icon-box'>
            {color === 'black' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Painting_Black} size='t' />}
            {color === 'white' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Painting_White} size='t' />}
            {color === 'red' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Painting_Red} size='t' />}
            <Icon imgClassName={'hover-icon'} icon={AssignmentStepStatus.Step_Painting_Red} size='t' />
          </div>
        )
      case OrderSteps.FINISHING: // 6
        return (
          <div className='icon-box'>
            {color === 'black' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Finishing_Black} size='t' />}
            {color === 'white' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Finishing_White} size='t' />}
            {color === 'red' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_Finishing_Red} size='t' />}
            <Icon imgClassName={'hover-icon'} icon={AssignmentStepStatus.Step_Finishing_Red} size='t' />
          </div>
        )
      case OrderSteps.DELIVERY: // 7
        return (
          <div className='icon-box'>
            {color === 'black' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_New_Black} size='t' />}
            {color === 'white' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_New_White} size='t' />}
            {color === 'red' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_New_Red} size='t' />}
            <Icon imgClassName={'hover-icon'} icon={AssignmentStepStatus.Step_New_Red} size='t' />
          </div>
        )
      case OrderSteps.DISASSEMBLY: // BodyShopDisassembly 101
        return (
          <div className='icon-box'>
            {color === 'black' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopDisassemply_Black} size='t' />}
            {color === 'white' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopDisassemply_White} size='t' />}
            {color === 'red' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopDisassemply_Red} size='t' />}
            <Icon imgClassName={'hover-icon'} icon={AssignmentStepStatus.Step_BodyShopDisassemply_Red} size='t' />
          </div>
        )
      case OrderSteps.REPAIR: // BodyShopRepair 102
        return (
          <div className='icon-box'>
            {color === 'black' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopRepair_Black} size='t' />}
            {color === 'white' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopRepair_White} size='t' />}
            {color === 'red' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopRepair_Red} size='t' />}
            <Icon imgClassName={'hover-icon'} icon={AssignmentStepStatus.Step_BodyShopRepair_Red} size='t' />
          </div>
        )
      case OrderSteps.ASSEMBLY: // BodyShopAssembly 103
        return (
          <div className='icon-box'>
            {color === 'black' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopAssembly_Black} size='t' />}
            {color === 'white' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopAssembly_White} size='t' />}
            {color === 'red' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopAssembly_Red} size='t' />}
            <Icon imgClassName={'hover-icon'} icon={AssignmentStepStatus.Step_BodyShopAssembly_Red} size='t' />
          </div>
        )
      case OrderSteps.BODY_FINISHING: // BodyShopFinishing 104
        return (
          <div className='icon-box'>
            {color === 'black' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopFinishing_Black} size='t' />}
            {color === 'white' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopFinishing_White} size='t' />}
            {color === 'red' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopFinishing_Red} size='t' />}
            <Icon imgClassName={'hover-icon'} icon={AssignmentStepStatus.Step_BodyShopFinishing_Red} size='t' />
          </div>
        )
      case OrderSteps.BODY_PAINTING: // BodyShopPainting 105
        return (
          <div className='icon-box'>
            {color === 'black' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopPainting_Black} size='t' />}
            {color === 'white' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopPainting_White} size='t' />}
            {color === 'red' && <Icon imgClassName={'main-icon'} icon={AssignmentStepStatus.Step_BodyShopPainting_Red} size='t' />}
            <Icon imgClassName={'hover-icon'} icon={AssignmentStepStatus.Step_BodyShopPainting_Red} size='t' />
          </div>
        )
      default:
        return null
    }
  }

  onStepClick (step, assignedUsersIds) {
    let bodyAllowedSteps = [103, 104, 7]
    // let restriction = !hasSubscriptionPermission(this.props.auth, 20) && assignedUsersIds.length > 0 && !assignedUsersIds.includes(this.props.activeEmployees[0])
    if (((step >= this.state.item.CurrentStep && step !== 105) || (this.state.item.CurrentStep === 105 && bodyAllowedSteps.includes(step)) || step === 7)) {
      if (this.props.activeEmployees.length === 0) {
        window.toastr.error(translation('1858'), translation('216'))
      } else {
        let data = {
          UserIds: this.props.activeEmployees,
          OrderId: this.state.item.OrderId,
          StepId: step
        }
        this.props.assignUsers(data).then((res) => {
          this.setState({
            item: res.data
          })
          this.props.onAssignUsers()
        }, () => {
          window.toastr.error(translation('1898'), translation('216'))
        })
      }
    }
  }

  renderStep (step, key) {
    if (step.Step === 105 && this.state.item.CurrentStep !== 105) return null
    // Extra class
    let extraClass = ''
    let iconColor = 'black'
    let unAssignClass = ''
    if (step.AssignedUsersIds.length === 0) {
      unAssignClass = ' unAssignStep'
      extraClass = unAssignClass
    }

    if (this.props.auth.departmentType !== 1) {
      if (step.Step === this.state.item.CurrentStep) {
        extraClass = 'currentStep' + unAssignClass
      } else if (step.Step < this.state.item.CurrentStep) {
        extraClass = 'disabled'
      }
      if (step.IsAssigned && step.Step >= this.state.item.CurrentStep) {
        extraClass = ' active'
      }
    } else {
      let stepArr = [1, 101, 102, 103, 104, 7]
      let bodyDisabledSteps = [1, 101, 102]
      if (step.Step === this.state.item.CurrentStep) {
        extraClass = 'currentStep' + unAssignClass
      } else if (stepArr.indexOf(step.Step) < stepArr.indexOf(this.state.item.CurrentStep) || this.state.item.CurrentStep === 105 && bodyDisabledSteps.includes(step.Step)) {
        extraClass = 'disabled'
      }
      if (step.IsAssigned && stepArr.indexOf(step.Step) >= stepArr.indexOf(this.state.item.CurrentStep)) {
        extraClass = ' active'
      }
      if (step.Step === 105) {
        extraClass += ' disabled'
      }
    }

    if (this.props.disabled) {
      extraClass = ' disabled'
    }

    // get icon color
    if (extraClass.indexOf('unAssignStep') !== -1) {
      iconColor = 'red'
    }
    if (extraClass.indexOf('active') !== -1) {
      iconColor = 'white'
    }

    const renderAriaText = (key, val) => {
      if (step.AssignedUsers.length !== 0) {
        if (step.Initials.length > 2 && val === '+') {
          return step.AssignedUsers.slice(key, step.AssignedUsers.length).join(', ')
        }
        return step.AssignedUsers[key]
      }
    }

    // Initials
    const renderInitials = () => {
      let assignedUsers = ''
      if (step.AssignedUsers.length !== 0) {
        let userInitials = step.Initials
        if (step.Initials.length > 2) {
          userInitials = step.Initials.slice(0, 1)
          userInitials.push('+')
        }
        let customComponent = userInitials.map((x, key) => { return {customComponent: Avatar, initials: x, noCircle: true, ariaText: renderAriaText(key, x), ariaPos: this.props.assignAriaPos, useHtmlTitleTag: this.props.useHtmlTitleTag} })
        assignedUsers = (<IconAccordion icons={customComponent} size='s' />)
      } else {
        if (extraClass !== 'disabled') {
          assignedUsers = (<Icon icon={AssignmentIcons.Warning} size='s' injectSvg />)
        }
      }
      return (
        <div className='stepInitials'>
          <div>{assignedUsers}</div>
          {assignedUsers === '' && step.Initials}
        </div>
      )
    }
    let itemWidth = (100 / (this.props.auth.departmentType === 1 && this.state.item.CurrentStep !== 105 ? 6 : 7)) + '%'

    // Return
    return (
      <div className={'step__item ' + extraClass} style={{width: itemWidth}} key={key} onClick={this.onStepClick.bind(this, step.Step, step.AssignedUsersIds)}>
        <div className='step__icons'>
          {this.getStepIcon(step.Step, iconColor)}
        </div>
        {renderInitials()}
        <div className='step__time'>
          {hasSubscriptionPermission(this.props.auth, 20) && step.AssignedTime}
        </div>
      </div>
    )
  }

  navigateToOrder () {
    let { item } = this.state
    this.props.router.push({
      pathname: '/orders/' + item.OrderId,
      state: {
        lastview: 'assign'
      }
    })
  }

  generateTitle () {
    let { item } = this.state
    let title = ''

    // Model
    if (item.Model) {
      title += item.Model
    }

    // RegNumber
    if (item.RegNumber) {
      if (item.Model) {
        title += ', '
      }
      title += item.RegNumber
    }

    // Title empty
    if (title === '') {
      title += item.OrderId
    }

    return title
  }

  renderProduction () {
    if (!hasAccess([3, 7], this.props.auth.user.UserType) || this.props.DontShowDeadline) return null
    let canChange = hasSubscriptionPermission(this.props.auth, 10, 13)

    let { item } = this.state
    const renderActionOpener = (triggerOpen) => {
      return (
        <div onClick={triggerOpen} className={'hint--left' + (canChange ? ' hasCursor' : '')} aria-label={translation('193')} >
          {hasSubscriptionPermission(this.props.auth, 10, 2) && this.renderTime(item.Delivery)}
        </div>
      )
    }
    const renderActionMenu = (triggerPopup) => {
      if (!canChange) return null
      const onSuccess = () => {
        triggerPopup()
        this.props.getAssignOrderData()
      }
      return (
        <DateActions item={item} orderId={item.OrderId} location='assign' onSuccess={onSuccess} />
      )
    }
    return (
      <DateChangePopup selfClick renderActionOpener={renderActionOpener} renderActionMenu={renderActionMenu} />
    )
  }

  render () {
    let { item } = this.state
    if (item === null) return null
    if (Object.keys(item).length === 0) return null
    let extraClass = ''
    if (item.IsStarted) extraClass = 'active'
    return (
      <div className={'assign__item ' + extraClass} data-index={this.props.index}>
        <div className='title clearfix' ><div className='left' onClick={this.navigateToOrder}>{this.generateTitle()}</div><div className='right'>{this.renderProduction()}</div></div>
        <div className='clearfix stepsController'>
          {item.Assignments.map(this.renderStep)}
        </div>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    activeEmployees: state.assign.activeEmployees
  }
}

AssignItem.defaultProps = {
  assignAriaPos: 'bottom'
}

export default connect(mapStateToProps, {
  assignUsers
})(AssignItem)



// WEBPACK FOOTER //
// ./src/app/pages/NewWorkscreen/AssignItem/index.js